// api/reservas.js - MODIFICADO
import { API_BASE } from '../utils/helpers';
const API_URL = `${API_BASE}/api/reservas`;

const buildActorQuery = (user) => {
  if (!user) return '';
  const params = new URLSearchParams();
  if (user.id) params.set('usuarioId', user.id);
  if (user.role) params.set('rol', user.role);
  if (user.email) params.set('email', user.email);
  if (user.telefono) params.set('telefono', user.telefono);
  const query = params.toString();
  return query ? `?${query}` : '';
};

// Helper genérico
async function handle(res) {
  if (!res.ok) {
    const status = res.status;
    const text = await res.text().catch(() => '');
    let errorMessage = text || `Error HTTP ${status}`;
    let parsed = null;
    try {
      parsed = JSON.parse(text);
      errorMessage = parsed.error || parsed.message || errorMessage;
    } catch (_) {}
    // Detectar respuesta HTML típica de ruta inexistente en backend remoto
    if (/<!DOCTYPE html>/i.test(text) || /<html/i.test(text)) {
      errorMessage = `Ruta no disponible en el servidor (HTTP ${status}). Es posible que el backend remoto no tenga aún la nueva funcionalidad de calificación desplegada.`;
    }
    console.error('[API reservas] Error response:', { status, body: text, parsed });
    const err = new Error(errorMessage);
    err.status = status;
    err.rawBody = text;
    err.parsed = parsed;
    throw err;
  }
  return res.json();
}

const toHHMMSS = (v) => {
  if (v == null) return null;
  const s = String(v).trim();
  const m = s.match(/(\d{1,2}:\d{2}(?::\d{2})?)/);
  if (!m) return null;
  const parts = m[1].split(':');
  const hh = String(parts[0]).padStart(2, '0');
  const mm = String(parts[1]).padStart(2, '0');
  const ss = parts[2] ? String(parts[2]).padStart(2, '0') : '00';
  return `${hh}:${mm}:${ss}`;
};

// Crear una reserva
export async function crearReserva(reserva) {
  const horaNorm = toHHMMSS(reserva.Hora);
  const body = {
    ...reserva,
    Hora: horaNorm, // garantizar HH:mm:ss
    // Duplicado por compatibilidad con posibles parsers de backend
    hora: horaNorm
  };

  console.log('Enviando reserva:', body);

  const res = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  return handle(res);
}

// Listar reservas
export async function obtenerReservas(user) {
  const res = await fetch(`${API_URL}${buildActorQuery(user)}`);
  return handle(res);
}

// Obtener reservas por usuario
export async function obtenerReservasUsuario(usuarioId) {
  const res = await fetch(`${API_URL}/usuario/${usuarioId}`);
  return handle(res);
}

// Cambiar estado de una reserva
export async function cambiarEstadoReserva(id, estado) {
  const res = await fetch(`${API_URL}/${id}/estado`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ Estado: estado }),
  });
  return handle(res);
}

// Posponer reserva con nueva fecha/hora y mensaje
export async function posponerReserva(id, { FechaNueva, HoraNueva, Notas }) {
  const horaNorm = toHHMMSS(HoraNueva);
  if (!horaNorm) {
    const msg = `HoraNueva inválida (recibido: ${HoraNueva}). Formato esperado HH:mm u HH:mm:ss`;
    console.warn('[API reservas] ' + msg);
    throw new Error(msg);
  }
  const body = {
    // Enviar varias variantes por compatibilidad con el backend
    FechaNueva,
    Fecha: FechaNueva,
    HoraNueva: horaNorm,
    Hora: horaNorm,
    hora: horaNorm,
    Notas
  };
  console.log('[API reservas] PATCH posponerReserva ->', { id, body });
  const res = await fetch(`${API_URL}/${id}/posponer`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return handle(res);
}

// Reagendar reserva: libera la hora y guarda un mensaje para el cliente
export async function reagendarReserva(id, { Mensaje }) {
  const body = { Mensaje };
  const res = await fetch(`${API_URL}/${id}/reagendar`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return handle(res);
}

// Calificar una reserva con estrellas (1-5) y comentario opcional
export async function calificarReserva(id, { Estrellas, Comentario }) {
  const body = { Estrellas, Comentario };
  console.log('[API reservas] PATCH calificacion ->', { id, body, url: `${API_URL}/${id}/calificacion` });
  const res = await fetch(`${API_URL}/${id}/calificacion`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  return handle(res);
}

// Listar reservas evaluadas (Calificacion no nula)
export async function obtenerReservasEvaluadas(user) {
  const res = await fetch(`${API_URL}/evaluadas${buildActorQuery(user)}`);
  return handle(res);
}

// Eliminar reserva (solo superadmin en backend)
export async function eliminarReserva(id, user) {
  const headers = { 'Content-Type': 'application/json' };
  if (user?.id) headers['x-user-id'] = String(user.id);
  if (user?.role) headers['x-user-role'] = user.role;
  const res = await fetch(`${API_URL}/${id}`, {
    method: 'DELETE',
    headers,
  });
  return handle(res);
}
